module.exports = __webpack_public_path__ + "static/media/internews-logo.d53c7f69.svg";